export default "/_next/static/images/1dad7c7cad816b146b784d440e0bf222.jpg";